import React from "react";
import GoogleAPILibStore from "../../stores/GoogleAPILibStore";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import SERPStore from "../../stores/SERPStore";
import SearchFiltersStore from "../../stores/SearchFiltersStore";
import PrivateSERPGoogleMapView from "../views/PrivateSERPGoogleMapView";
import PrivateSERPFiltersView from "../views/PrivateSERPFiltersView";
import PrivateSpaceCardListView from "../views/PrivateSpaceCardListView";
import LoadingView from "../views/LoadingView";
import SERPFooterView from "../views/SERPFooterView";

export default class PrivateSpaceSERPContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "googleAPILibState": GoogleAPILibStore.getState(),
            "SERPState": SERPStore.getState(),
            "searchFiltersState": SearchFiltersStore.getState(),
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.SERPState.activePage !== prevState.SERPState.activePage) {
            EventPublisher.publish(UIInteractionEvents.LOAD_SPACES, {
                "placeId": this.state.SERPState.googlePlaceId,
                "maxPrice": this.state.searchFiltersState.maxPrice,
                "minPrice": this.state.searchFiltersState.minPrice,
                "orderBy": this.state.searchFiltersState.orderBy,
                "distance": this.state.searchFiltersState.distance,
                "latitude": this.state.SERPState.mapCurrentCenter.latitude,
                "longitude": this.state.SERPState.mapCurrentCenter.longitude,
                "activePage": this.state.SERPState.activePage});
        }
    }

    componentDidMount() {
        this.googleAPILibStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.GOOGLE_API_LIB_STORE_UPDATED, this.handleStoreUpdate);
        this.serpStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.SERP_STORE_UPDATED, this.handleStoreUpdate);
        this.searchFiltersStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.SEARCH_FILTERS_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.GOOGLE_API_LIB_REQUIRED, {});
        EventPublisher.publish(UIInteractionEvents.LOAD_INITIAL_SPACES, {
            "placeId": this.state.SERPState.googlePlaceId,
            "maxPrice": this.state.searchFiltersState.maxPrice,
            "minPrice": this.state.searchFiltersState.minPrice,
            "orderBy": this.state.searchFiltersState.orderBy,
            "distance": this.state.searchFiltersState.distance,
            "latitude": 0,
            "longitude": 0,
            "activePage": this.state.SERPState.activePage});
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.googleAPILibStoreSubscriber);
        EventPublisher.unsubscribe(this.serpStoreSubscriber);
        EventPublisher.unsubscribe(this.searchFiltersStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "googleAPILibState": GoogleAPILibStore.getState(),
            "SERPState": SERPStore.getState(),
            "searchFiltersState": SearchFiltersStore.getState(),
        });
    };

    render() {
        if (this.state.googleAPILibState.loadingState !== LoadingStates.FINISHED_LOADING) {
            return (
                <LoadingView titleText="Loading Google Maps"/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-8 nopadding everything-fixed-after-top-bar">
                        <div className="card">
                            <div className="card-header tight-card-header">
                                <GooglePlacesAutocomplete
                                    minLengthAutocomplete={4}
                                    selectProps={{
                                        placeholder: "Search locations by ZIP, City, or Address",
                                        blurInputOnSelect: true,
                                        noOptionsMessage: () => {
                                            return "Type more for suggestions...";
                                        },
                                        onChange:(address) =>
                                            {
                                                EventPublisher.publish(
                                                    UIInteractionEvents.GOOGLE_PLACES_AUTO_COMPLETE_SERP_CHANGE,
                                                    {
                                                        "placeId": address.value.place_id,
                                                        "maxPrice": this.state.searchFiltersState.maxPrice,
                                                        "minPrice": this.state.searchFiltersState.minPrice,
                                                        "orderBy": this.state.searchFiltersState.orderBy,
                                                        "distance": this.state.searchFiltersState.distance,
                                                        "latitude": 0,
                                                        "longitude": 0,
                                                        "activePage": this.state.SERPState.activePage
                                                    }
                                                )
                                            }
                                    }}
                                />
                            </div>
                        </div>
                        <PrivateSERPGoogleMapView
                            longitude={this.state.SERPState.data.longitude}
                            latitude={this.state.SERPState.data.latitude}
                            results={this.state.SERPState.data.results}
                            loadingState={this.state.SERPState.loadingState}
                            zoomLevel={this.state.searchFiltersState.zoomLevel}
                            maxPrice={this.state.searchFiltersState.maxPrice}
                            minPrice={this.state.searchFiltersState.minPrice}
                            orderBy={this.state.searchFiltersState.orderBy}
                            place_id={this.state.SERPState.googlePlaceId}
                            distance={this.state.searchFiltersState.distance}
                            mapCurrentCenter={this.state.SERPState.mapCurrentCenter}/>
                    </div>
                    <div className="col-md-4 scrollable-column ml-auto">
                        <div className="row">
                            <PrivateSERPFiltersView
                                maxPrice={this.state.searchFiltersState.maxPrice}
                                minPrice={this.state.searchFiltersState.minPrice}
                                orderBy={this.state.searchFiltersState.orderBy}
                                placeId={this.state.SERPState.googlePlaceId}
                                distance={this.state.searchFiltersState.distance}
                                mapCurrentCenter={this.state.SERPState.mapCurrentCenter}
                                activePage={this.state.SERPState.activePage}
                            />
                        </div>
                        <div className="row">
                            <PrivateSpaceCardListView
                                spaces={this.state.SERPState.data.results}
                                selectedSpace={this.state.SERPState.selectedSpace}
                                loadingState={this.state.SERPState.loadingState}
                                totalCount={this.state.SERPState.data.count}
                                currentActivePage={this.state.SERPState.activePage}
                            />
                        </div>
                        <div className="row">
                            <SERPFooterView />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}